/* A/B test: mobile-menu GA4 click tracking for both menus. Spec: docs/ab-tests/2026-09-18-mobile-menu.md */
class AbMenuTracking extends HTMLElement {
  connectedCallback() {
    this.menu = this.closest('main-menu');
    if (!this.menu) return;
    this.desktopQuery = window.matchMedia(window.theme?.mediaQueries?.md || '(min-width: 769px)');
    this.onClick = this.handleClick.bind(this);
    this.onDrawerOpen = () => this.send('mobile_menu_click', { label: 'Menu', action: 'open', category: 'Header', variant: 'test' });
    this.menu.addEventListener('click', this.onClick);
    this.menu.addEventListener('on:ab-mm:open', this.onDrawerOpen);
    window.addEventListener('ig:ready', this.onIgReady);
  }

  disconnectedCallback() {
    if (!this.menu) return;
    this.menu.removeEventListener('click', this.onClick);
    this.menu.removeEventListener('on:ab-mm:open', this.onDrawerOpen);
    window.removeEventListener('ig:ready', this.onIgReady);
  }

  handleClick(evt) {
    if (this.desktopQuery.matches) return;

    const controlToggle = evt.target.closest('.main-menu__toggle');
    if (controlToggle) {
      const disclosure = controlToggle.closest('details');
      if (disclosure && !disclosure.classList.contains('is-open')) {
        this.send('mobile_menu_click', { label: 'Menu', action: 'open', category: 'Header', variant: 'control' });
      }
      return;
    }

    const el = evt.target.closest('[data-mm-el]');
    if (!el || !this.menu.contains(el)) return;

    const screen = el.closest('[data-mm-screen-label]');
    const link = el.matches('a[href]') ? el : el.querySelector('a[href]');
    const action = el.dataset.mmUrl || (link && link.getAttribute('href')) || el.dataset.mmEl;

    this.send('mobile_menu_click', {
      label: (el.dataset.mmLabel || el.textContent).trim().slice(0, 100),
      action,
      category: el.dataset.mmEl === 'category' || !screen ? 'Main' : screen.dataset.mmScreenLabel,
      variant: el.closest('ab-mobile-menu') ? 'test' : 'control',
    });
  }

  send(name, params) {
    window.Shopify?.analytics?.publish?.(name, params);
  }
}

if (!customElements.get('ab-menu-tracking')) {
  customElements.define('ab-menu-tracking', AbMenuTracking);
}
